import { Button, Link, TextBlock } from '../../atoms';
import { createUrl } from '../../../helpers/urlHelper';
import React from 'react';
import useStyles from './FileResultModal.styles';

interface Detail {
  text: string | undefined;
  usersNotFoundList?: string[];
}

interface FileResultModalProps {
  open?: boolean;
  headerText: string;
  text: string;
  details: Detail[];
  downloadMessageText?: string;
  showSuccessMessageOnly: boolean;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
  usersNotFoundList?: string[];
}

const FileResultModal: React.FC<FileResultModalProps> = ({
  open,
  headerText,
  text,
  details,
  downloadMessageText,
  showSuccessMessageOnly,
  buttonText,
  buttonSize,
  handleButtonClick,
}) => {
  const classes = useStyles();

  return (
    <>
      {open && (
        <div className={classes.root}>
          <div className={classes.titleContainer}>
            <div className={classes.title}>
              <TextBlock type="titleErrorModalTB" text={headerText} />
            </div>
          </div>
          {!showSuccessMessageOnly && (
            <div className={classes.textContainerWithDetails}>
              <TextBlock
                type="fileUploadModalTB"
                text={text}
                alignCenter={true}
              />
              {details.map((detail, index) => (
                <TextBlock
                  key={index}
                  type="fileUploadModalTB"
                  text={detail.text}
                  alignCenter={true}
                />
              ))}
              <div className={classes.downloadTextContainer}>
                <Link
                  text={'Download'}
                  type={'fileDownloadLink'}
                  download={'notFoundCanaryUsers.txt'}
                  url={createUrl(
                    details[details.length - 1].usersNotFoundList || [],
                  )}
                />
                <TextBlock
                  type="fileUploadModalTB"
                  text={downloadMessageText}
                  alignCenter={true}
                  leftFloat={true}
                />
              </div>
            </div>
          )}
          {showSuccessMessageOnly && (
            <div className={classes.textContainerSuccess}>
              <TextBlock
                type="fileUploadModalTB"
                text={text}
                alignCenter={true}
              />
            </div>
          )}
          <div className={classes.buttons}>
            <Button onAction={handleButtonClick} color="blue" size={buttonSize}>
              {buttonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default FileResultModal;
